import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { HelichrysumIcon } from "@/components/brand/HelichrysumIcon";

const TEXT =
  "Dopo una vita intera, la pelle merita una cura che la conosca davvero. Perfero nasce per la generazione d'argento: formule delicate con postbiotici dell'elicriso, pensate per proteggere, nutrire e restituire comfort. Ogni giorno, con dignità.";

const WORDS = TEXT.split(" ");

const Word = ({ children, progress, range }) => {
  const color = useTransform(progress, range, ["#8A7A6A", "#0F1E33"]);
  return (
    <motion.span style={{ color }} className="mr-[0.24em] inline-block">
      {children}
    </motion.span>
  );
};

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.55"] });
  return (
    <section className="bg-ivory py-28 lg:py-44" data-testid="manifesto-section">
      <div className="container-pf grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-3">
          <p className="eyebrow">Il nostro manifesto</p>
          <HelichrysumIcon className="mt-6 h-12 w-12 text-gold" />
        </div>
        <p ref={ref} className="font-display text-[2rem] leading-[1.15] sm:text-5xl lg:col-span-9 lg:text-[3.5rem]">
          {WORDS.map((w, i) => (
            <Word key={i} progress={scrollYProgress} range={[i / WORDS.length, (i + 1) / WORDS.length]}>
              {w}
            </Word>
          ))}
        </p>
      </div>
    </section>
  );
};
